import axios from 'src/utils/axios';

export const getArtemisProductHistory = ({ KUL_MODEL_KODU, UYIL, UDONEM, SERINO, NITELIK_KODU }) => {
  return axios.get(`/GetArtemisUrunTarihce/${KUL_MODEL_KODU}/${UYIL}/${UDONEM}/${SERINO}/${NITELIK_KODU}`);
};
